import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSelectDropdownComponent from './adpSelectDropdown.component';

let adpSelectDropdownModule = angular.module('adpSelectDropdown', [
  uiRouter
])

.component('adpSelectDropdown', adpSelectDropdownComponent)

.name;

export default adpSelectDropdownModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSelectDropdown/adpSelectDropdown.js